export const STORY_ROUTES = {
	BASE: 'story',
	PROJECT: 'project',
	CLIENT: 'client',
	KEY_MOMENTS: 'key-moments',
        SEO: 'seo',
        FEEDBACK: 'feedback',
        FEEDBACK_VALIDATION: 'feedback-validation',
	ALL_STORIES: 'all',
	TECHNOLOGY: 'technology',
	MEETING: 'meeting',
	TEAM_MEMBERS: 'members',
	REORDER: 'reorder',
	UPDATE_ROLE: 'update-role',
	// story common routes
	RESTORE: 'restore',
	DELETE_FOREVER: 'delete-forever',
	FEATURE: 'feature',
	VALIDATE_PREVIEW: 'validate-preview',
	PUBLISH_WEB: 'publish-web',
	PUBLISH_BRIGHTR: 'publish-brightr',
	UNPUBLISH_BRIGHTR: 'unpublish-brightr',
	UNPUBLISH_WEB: 'unpublish-web',
	// story from url routes
	CREATE_STORY_FROM_URL_CAMPAIGN: 'create-story-from-url-campaign',
	CHECK_STORY_FROM_URL_IDENTIFIER: 'check-story-from-url-identifier',
	// 
	CREATE_STORY_FROM_URL_EXISTING_USER: 'create-story-from-url-existing-user',
} as const
type StoryRoutes = (typeof STORY_ROUTES)[keyof typeof STORY_ROUTES]

// Фильтруем нужные значения
export type ValidPublishActions = Extract<StoryRoutes, 'publish-web' | 'publish-brightr' | 'unpublish-brightr' | 'unpublish-web'>
// export type ValidPublishActions = Pick<typeof STORY_ROUTES, 'PUBLISH_WEB' | 'PUBLISH_BRIGHTR' | 'UNPUBLISH_WEB' | 'UNPUBLISH_BRIGHTR'>;

export const getAllStories = (): string => {
	return `/${STORY_ROUTES.BASE}/${STORY_ROUTES.ALL_STORIES}`
}

export const getStoryUrl = (storyId: string): string => {
	return `/${STORY_ROUTES.BASE}/${storyId}`
}
export const getStoryDeleteSoftUrl = (storyId: string): string => {
	return `/${STORY_ROUTES.BASE}/${storyId}`
}
export const getStoryDeleteForeverUrl = (storyId: string): string => {
	return `/${STORY_ROUTES.BASE}/${storyId}/${STORY_ROUTES.DELETE_FOREVER}`
}
export const getStorySetAsFeaturedUrlPatch = (storyId: string): string => {
	return `/${STORY_ROUTES.BASE}/${storyId}/${STORY_ROUTES.FEATURE}`
}
export const getStoryRestoreUrlPatch = (storyId: string): string => {
	return `/${STORY_ROUTES.BASE}/${storyId}/${STORY_ROUTES.RESTORE}`
}
export const getStoryValidatePreviewUrl = (storyId: string): string => {
	return `/${STORY_ROUTES.BASE}/${storyId}/${STORY_ROUTES.VALIDATE_PREVIEW}`
}

export const getStoryPublishOrUnpublishUrlPatchByAction = (storyId: string, action: ValidPublishActions): string => {
	switch (action) {
		case 'publish-web':
			return getStoryPublishWebUrlPatch(storyId)
		case 'publish-brightr':
			return getStoryPublishBrightrUrlPatch(storyId)
		case 'unpublish-brightr':
			return getStoryUnpublishBrightrUrlPatch(storyId)
		case 'unpublish-web':
			return getStoryUnpublishWebUrlPatch(storyId)
		default:
			throw new Error('Invalid action')
	}
}

export const getStoryPublishWebUrlPatch = (storyId: string): string => {
	return `/${STORY_ROUTES.BASE}/${storyId}/${STORY_ROUTES.PUBLISH_WEB}`
}

export const getStoryPublishBrightrUrlPatch = (storyId: string): string => {
	return `/${STORY_ROUTES.BASE}/${storyId}/${STORY_ROUTES.PUBLISH_BRIGHTR}`
}

export const getStoryUnpublishBrightrUrlPatch = (storyId: string): string => {
	return `/${STORY_ROUTES.BASE}/${storyId}/${STORY_ROUTES.UNPUBLISH_BRIGHTR}`
}

export const getStoryUnpublishWebUrlPatch = (storyId: string): string => {
	return `/${STORY_ROUTES.BASE}/${storyId}/${STORY_ROUTES.UNPUBLISH_WEB}`
}

// story wizard urls

export const getStoryProjectUrlPost = (storyId: string): string => {
	return `/${STORY_ROUTES.BASE}/${storyId}/${STORY_ROUTES.PROJECT}`
}
export const getStoryClientUrlPost = (storyId: string): string => {
	return `/${STORY_ROUTES.BASE}/${storyId}/${STORY_ROUTES.CLIENT}`
}

export const getStoryKeyMomentsUrlPost = (storyId: string): string => {
	return `/${STORY_ROUTES.BASE}/${storyId}/${STORY_ROUTES.KEY_MOMENTS}`
}

export const getStoryTechnologyUrlPost = (storyId: string): string => {
	return `/${STORY_ROUTES.BASE}/${storyId}/${STORY_ROUTES.TECHNOLOGY}`
}

export const getStoryTechnologyUrlDelete = (storyId: string, technologyId: string): string => {
	return `/${STORY_ROUTES.BASE}/${storyId}/${STORY_ROUTES.TECHNOLOGY}/${technologyId}`
}

export const getStoryTechnologyUrlAddSinglePost = (storyId: string, technologyId: string): string => {
	return `/${STORY_ROUTES.BASE}/${storyId}/${STORY_ROUTES.TECHNOLOGY}/${technologyId}`
}
export const getStoryTechnologyUrlReorderPost = (storyId: string): string => {
	return `/${STORY_ROUTES.BASE}/${storyId}/${STORY_ROUTES.TECHNOLOGY}/${STORY_ROUTES.REORDER}`
}

export const getStoryTeamMembersUrlPost = (storyId: string): string => {
	return `/${STORY_ROUTES.BASE}/${storyId}/${STORY_ROUTES.TEAM_MEMBERS}`
}
export const getStoryTeamMembersUrlReorderPost = (storyId: string): string => {
	return `/${STORY_ROUTES.BASE}/${storyId}/${STORY_ROUTES.TEAM_MEMBERS}/${STORY_ROUTES.REORDER}`
}

export const getStoryTeamMembersUrlDelete = (storyId: string, teamMemberId: string): string => {
	return `/${STORY_ROUTES.BASE}/${storyId}/${STORY_ROUTES.TEAM_MEMBERS}/${teamMemberId}`
}

export const getStoryTeamMembersUrlAddSinglePost = (storyId: string, teamMemberId: string): string => {
	return `/${STORY_ROUTES.BASE}/${storyId}/${STORY_ROUTES.TEAM_MEMBERS}/${teamMemberId}`
}

export const getStoryTeamMembersUrlUpdateRolePost = (storyId: string, teamMemberId: string): string => {
	return `/${STORY_ROUTES.BASE}/${storyId}/${STORY_ROUTES.TEAM_MEMBERS}/${STORY_ROUTES.UPDATE_ROLE}/${teamMemberId}`
}

export const getStorySeoUrlPost = (storyId: string): string => {
	return `/${STORY_ROUTES.BASE}/${storyId}/${STORY_ROUTES.SEO}`
}
export const getStoryMeetingUrlPost = (storyId: string): string => {
	return `/${STORY_ROUTES.BASE}/${storyId}/${STORY_ROUTES.MEETING}`
}

export const getStoryFeedbackUrlPost = (storyId: string): string => {
        return `/${STORY_ROUTES.BASE}/${storyId}/${STORY_ROUTES.FEEDBACK}`
}

export const getStoryFeedbackValidationUrl = (storyId: string): string => {
        return `/${STORY_ROUTES.BASE}/${storyId}/${STORY_ROUTES.FEEDBACK_VALIDATION}`
}
export const getStoryFeedbackValidationUrlPost = getStoryFeedbackValidationUrl
export const getStoryFeedbackValidationUrlDelete = getStoryFeedbackValidationUrl

export const getAllStoryTechnologies = (storyId: string): string => {
	return `/${STORY_ROUTES.BASE}/${storyId}/${STORY_ROUTES.TECHNOLOGY}`
}
// story from url routes
export const getStoryFromUrlCampaignUrlPost = (): string => {
	return `/${STORY_ROUTES.BASE}/${STORY_ROUTES.CREATE_STORY_FROM_URL_CAMPAIGN}`
}
export const getStoryFromUrlExistingUserUrlPost = (): string => {
	return `/${STORY_ROUTES.BASE}/${STORY_ROUTES.CREATE_STORY_FROM_URL_EXISTING_USER}`
}
export const getStoryFromUrlCampaignCheckIdentifierUrl = (): string => {
	return `/${STORY_ROUTES.BASE}/${STORY_ROUTES.CHECK_STORY_FROM_URL_IDENTIFIER}`
}
